import { useEffect } from 'react';
import type { Cart } from '@storefront/lib-global/codegen/types';
import { useCartContext } from '@storefront/lib-global/context/cartContext';
import { useLocaleContext } from '@storefront/lib-global/context/localeContext';
import { useOverlayContext } from '@storefront/lib-global/context/overlayContext';
import { useAddToCartMutation } from '@storefront/lib-global/graphqlDocument/cart/addToCart.generated';
import { useNRBASession } from '@storefront/lib-global/hooks/useNRBASession';
import { setCartLocalStorageItems } from '@storefront/lib-global/utils/cartUtils';

export function useAddToBag() {
  const { locale } = useLocaleContext();
  const { setMiniCart, setCartId, setGuid, setAnonymousId, setShowConfirmationMessage } = useCartContext();
  const { setIsMiniCartOpen } = useOverlayContext();
  const nrbaContextHeader = useNRBASession();

  const [addToCartMutation, { loading, data: addToBagData }] = useAddToCartMutation(nrbaContextHeader);

  useEffect(() => {
    if (addToBagData?.addToCart) {
      const { errors } = addToBagData.addToCart;
      const hasLineItemError = errors?.some((err) => err?.__typename === 'LineItemError');

      if (!hasLineItemError) {
        const cartId = addToBagData.addToCart.id ?? null;
        const anonId = addToBagData?.addToCart.anonymousId ?? null;
        const guid = addToBagData?.addToCart?.guid ?? null;
        setMiniCart(addToBagData?.addToCart as Cart);
        setCartId(cartId);
        setAnonymousId(anonId ?? '');
        setGuid(guid ?? '');
        setShowConfirmationMessage(true);
        setIsMiniCartOpen(true);
        setCartLocalStorageItems(locale, cartId, anonId, guid);
      }
    }
  }, [
    addToBagData,
    locale,
    setIsMiniCartOpen,
    setShowConfirmationMessage,
    setMiniCart,
    setAnonymousId,
    setCartId,
    setGuid,
  ]);

  return { addToBag: addToCartMutation, addToBagData, addToBagLoading: loading };
}
